import { capitalizeWords } from '@zoocasa/node-kit/strings/capitalize';

export function standardizedCityName(cityName: string): string {
  if (!cityName) return '';
  const normalized = cityName.trim().toLowerCase();
  if (normalized === 'saint catharines' || normalized === 'saint catherines') {
    return 'St. Catharines';
  }
  
  return capitalizeWords(cityName);
} 